import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'
import { type HttpClientError } from 'core/infra/http/HttpClient'

import { confirmBook, type ConfirmBookParams } from '../../use-cases/confirmBook'

export function useConfirmBook() {
  const [bookingErrorCode, setBookingErrorCode] = useState<number | undefined>()
  const [confirmBookStatus, setConfirmBookStatus] = useState(RequestStatus.Initial)
  const isConfirming = confirmBookStatus === RequestStatus.Pending

  const confirmBookFn = useCallback(async (params: ConfirmBookParams) => {
    try {
      setConfirmBookStatus(RequestStatus.Pending)
      await confirmBook(params)
      setConfirmBookStatus(RequestStatus.Done)
    } catch (e) {
      const error = e as HttpClientError<unknown>
      setBookingErrorCode(error.response?.status)
      setConfirmBookStatus(RequestStatus.Error)
      throw e
    }
  }, [])

  return { isConfirming, confirmBookStatus, bookingErrorCode, confirmBook: confirmBookFn }
}
